import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const BoldDescription = ({ txt, description }) => {
  let parts = txt.split(description);
  return (
    <div>
      <span>{parts[0]}</span>
      <strong>{description}</strong>
      <span>{parts[1]}</span>
    </div>
  );
};

BoldDescription.propTypes = {
  txt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const DisplayingText = (props) => {
  const { t } = useTranslation("contractsTranslation");
  return (
    <>
      {
        <BoldDescription
          description={t("Description")}
          txt={t(
            "Select the main reason for changing your subscriptions and provide more details in the Description box."
          )}
        />
      }
    </>
  );
};

export default DisplayingText;